import React from 'react';
import { put, call } from 'redux-saga/effects';
import { takeLatest } from '../../../utils/reduxSaga';
import orderBy from 'lodash.orderby';

import { URLS } from '../../../consts/endpoints';
import { actions as sagaActions, GET_SELECT_OPTIONS } from './types';
import { actions as reduxActions } from '../reducers';
import { getData } from '../../../utils/http';
import { isArrayEmpty, isDefined, isUndefined } from '../../../utils/isDefined';
import Optional from '../../../utils/optional';
import { translate } from '../../../i18n/I18nProvider';

export function getAllSelectOptions(clientId, fromIoT, getProviders) {
  return {
    type: sagaActions[GET_SELECT_OPTIONS],
    clientId,
    fromIoT,
    getProviders
  };
}

export function* getSelectOptions({ clientId, fromIoT, getProviders }) {
  let accountsSelectsOptions = [];
  let providersSelectsOptions = [];

  try {
    const data = yield call(
      getData,
      `${URLS.QUOTE_CLIENTS}/${clientId}/accounts`
    );

    const { mappedAcounts } = yield call(createAccountsOptions, data);

    accountsSelectsOptions = mappedAcounts;
  } catch {}

  if (accountsSelectsOptions.length === 1) {
    yield put(
      reduxActions.setSimcardData(
        { account: accountsSelectsOptions[0] },
        'firstStep'
      )
    );
  }
  if (getProviders === true) {
    if (accountsSelectsOptions.length > 0) {
      const customerAccount = accountsSelectsOptions.find(
        el => el.type === 'CUSTOMER'
      );

      const accountReference = Optional(customerAccount?.externalReference).or(
        Optional(accountsSelectsOptions[0]?.externalReference).or(null)
      );

      if (isDefined(accountReference)) {
        const products = yield call(
          getData,
          `${
            URLS.QUOTE_CLIENTS
          }/${clientId}/products?account_reference=${accountReference}&category=${
            fromIoT ? 'IoT' : 'Mobil Abonnementer'
          }`
        );

        providersSelectsOptions = yield call(mapProvidersOptions, {
          fromIoT,
          products,
          accountReference
        });
      }
    }
  }

  yield put(reduxActions.setProvidersOptions(providersSelectsOptions));
  yield put(reduxActions.setAccountOptions(accountsSelectsOptions));
}

function* watchGetSelectOptions() {
  yield takeLatest(sagaActions[GET_SELECT_OPTIONS], getSelectOptions);
}

export default watchGetSelectOptions();

export function createAccountsOptions(data = []) {
  if (isArrayEmpty(data)) {
    return { mappedAcounts: [] };
  }

  let mappedAcounts = [
    ...data.map(el => {
      const { name, accountNo, type } = el;
      return {
        value: `${name} - ${accountNo}`,
        label: (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {type === 'CUSTOMER' ? (
              <i className="fas fa-handshake-alt"></i>
            ) : (
              <i className="fal fa-money-bill-alt"></i>
            )}
            <div style={{ marginLeft: '5px' }}>{`${name} - ${accountNo}`}</div>
          </div>
        ),
        shortLabel: `${name} - ${accountNo}`,
        ...el
      };
    })
  ];

  if (mappedAcounts.length > 1) {
    const customerAccounts = mappedAcounts.filter(el => el.type === 'CUSTOMER');
    const invoiceAccounts = mappedAcounts.filter(el => el.type === 'INVOICE');

    mappedAcounts = [
      ...orderBy(customerAccounts, 'shortLabel'),
      ...orderBy(invoiceAccounts, 'shortLabel')
    ];
  }

  return { mappedAcounts };
}

export const mapProvidersOptions = ({
  fromIoT,
  products,
  accountReference,
  filteredProducts
}) => {
  const accountProducts =
    Optional(filteredProducts).or(products?.[accountReference]) || [];

  const providersOptions = accountProducts.reduce((arr, product) => {
    const provider = product?.specification?.network;

    if (isUndefined(provider)) {
      return arr;
    }

    if (isDefined(arr.find(el => el === provider))) {
      return arr;
    }

    return [...arr, provider];
  }, []);

  if (isArrayEmpty(providersOptions)) {
    return [{ value: '', label: '' }];
  }

  return !fromIoT
    ? providersOptions.map(provider => ({
        value: `${provider} NET`,
        label: `${provider} ${translate('TABLE.NETWORK').toLowerCase()}`
      }))
    : providersOptions.map(provider => ({
        value: `${provider} IoT`,
        label: `${provider} ${translate('TABLE.NETWORK').toLowerCase()} IoT`
      }));
};
